import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestauranteService } from 'src/app/services/restaurante.service';
import { Restaurante } from 'src/app/models/restaurante';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { GLOBAL } from '../../../services/global';
import { rest } from 'lodash';
import { FollowService } from 'src/app/services/follow.service';
import { MetricaService } from 'src/app/services/metrica.service';
import { faCamera } from '@fortawesome/fontawesome-free';

@Component({
  selector: 'app-info-restaurante',
  templateUrl: './info-restaurante.component.html',
  styleUrls: ['./info-restaurante.component.css']
})

export class InfoRestauranteComponent implements OnInit {

  arrayBotones = [];
  arrayFiltros = [];
  slug: any;
  id: any;
  closeResult: string;
  url = "";
  cartaQR: boolean = false;
  followRestaurant: boolean = false;
  resultInsertFollowRestaurant: any;
  userLogin: any;
  resultInsertFollow: any;
  urlContactoWhatsapp: string = "";
  pos: any = null;
  pantallaCarga: boolean = false;
  posRestaurante: any = null;
  hosteleria: boolean = false;
  iconComercio: string = "/assets/icons/comercio_info.png";
  iconHosteleria: string = "/assets/icons/hosteleria_info.png";
  iconRuta: string = "/assets/icons/ruta_info.png";
  diasSemana = [
    'lunes',
    'martes',
    'miercoles',
    "jueves",
    "viernes",
    "sabado",
    "domingo"
  ];
  diaSemanaHoy: any = 0;
  verTodoHorario = false;

  @Input() establecimiento: any;

  constructor(
    private route: ActivatedRoute,
    private rService: RestauranteService,
    private modalService: NgbModal,
    private followService: FollowService,
    private mService: MetricaService,
    private router: Router
  ) {
    
  }

  ngOnInit() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    this.url = GLOBAL.url;

    const hoy = new Date();
    this.diaSemanaHoy = hoy.getDay() - 1;

    if (this.diaSemanaHoy < 0) {
      this.diaSemanaHoy = 6;
    }

    this.route.params.subscribe(result => {
      // this.arrayBotones = GLOBAL.arrayBotones(result.id);
      // this.id = result.id;
      this.arrayBotones = GLOBAL.arrayBotones(result.slug);
      this.slug = result.slug;
    });

    let currentUrl = window.location.href;
    if (currentUrl.indexOf("QR") != -1) {
      this.cartaQR = true;
      this.arrayBotones = GLOBAL.arrayBotonesQR(this.id);
    }

    this.formatearDatosRestaurante();

  }

  formatearDatosRestaurante() {
    this.establecimiento.horario = [];

    this.diasSemana.forEach((dia, index) => {
      this.establecimiento.horario[index] = this.establecimiento["horario_" + dia];
    });
  }

  addMetrica(tipo) {
    let modeloMetrica = {
      establecimiento_id: this.id
    }

    if (tipo == "llamar") {
      modeloMetrica["tipo_interaccion"] = 11;//llamar
    }else if (tipo == "click_boton_ir_A") {
      modeloMetrica["tipo_interaccion"] = 10;//click_boton_ir_A
    }

    this.mService.addMetrica(modeloMetrica).subscribe(result => {
      if (result.result == "ok") {
        console.log("Guardar en metrica");
      } else {
        console.log("Error guardar en metrica");
      }
    });
  }

  onClickLikeRestaurant() {
    this.followService.setSeguidorRestaurante(this.establecimiento.id, this.userLogin.id).subscribe(result => {
      this.resultInsertFollowRestaurant = result;

      if (this.resultInsertFollowRestaurant.result == "ok") {
        this.followRestaurant = true;
      }

      if (this.resultInsertFollowRestaurant.result == "delete") {
        this.followRestaurant = false;
      }
    });
  }

  navegar(direccion) {
    this.router.navigate([direccion]);
  }

  llamar(numeroTelefono) {
    window.location.href = 'tel:+34' + numeroTelefono;
    this.addMetrica("llamar");
  }

  clickIrA() {

    if (this.pos == null) {
      this.pantallaCarga = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          const url = `https://www.google.com/maps/dir/?api=1&origin=${this.pos.lat},${this.pos.lng}&destination=${this.establecimiento.lat},${this.establecimiento.lng}&travelmode=walking`;
          window.open(url, '_blank');
          this.pantallaCarga = false;
        }, (error) => {
          this.pantallaCarga = false;
        });
      }
    } else {
      const url = `https://www.google.com/maps/dir/?api=1&origin=${this.pos.lat},${this.pos.lng}&destination=${this.establecimiento.lat},${this.establecimiento.lng}&travelmode=walking`;
      window.open(url, '_blank');
    }

    this.addMetrica("click_boton_ir_A");
  }

  navegarWebsite() {

    let url = "";

    if (this.establecimiento.website.indexOf("https://") !== -1) {
      url = this.establecimiento.website;
    } else {
      url = "https://" + this.establecimiento.website;
    }

    window.open(url, '_blank');
  }

  cambiarVerHorario() {
    this.verTodoHorario = !this.verTodoHorario;
  }


}
